import { useCallback } from "react";
import { useApi } from "./api";
import { SendFeedbackBody } from "./types/feedbacks";
import { buildHelpRequestFormData } from "./useHelpRequests";

export const useFeedbacksApi = () => {
  const api = useApi();

  // Send a test user's feedback to the developer and the project manager
  const sendFeedback = useCallback(
    (body: SendFeedbackBody) => {
      const formData = buildHelpRequestFormData(body);
      formData.append("type", body.type);
      return api.postNoResult<FormData>("/feedbacks", formData);
    },
    [api],
  );

  return { sendFeedback };
};
